import { MakeCallDto } from "../dtos/Call/MakeCallDto";
import HttpClient from "../HttpClient";

export default class CallServices {
    async makeCall(makeCallDto: MakeCallDto) {
        const res = await HttpClient.post("/call", makeCallDto);
        return res.data;
    }

    async patchAdminPhoneNumber(adminId: number | null, mobileNumber: string) {
        const req = {
            mobile: mobileNumber
        }
        const res = await HttpClient.patch(`/admin-user/admin/${adminId}`, req);
        return res.data;
    }

    async getCallLogsForRef(limit: number, offset: number, sort: any, referenceModelName: string, referenceId: number) {
        const res = await HttpClient.get(`/call/${referenceModelName}/${referenceId}/logs`, {
            params: {
                limit,
                offset,
                sort,
            }
        });
        return res;
    }

}